/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TagIcon20Solid = forwardRef('TagIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.75 4a2.5 2.5 0 0 0-2 1L1.125 8.5a2.5 2.5 0 0 0 0 3L3.75 15a2.5 2.5 0 0 0 2 1H15a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5.75ZM6 11.252a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" })));
});
